import { useTranslation } from 'react-i18next';

import { useLogout } from '~/api/auth';
import { Button, Drawer, Navigation } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';
import { srOnlyStyle } from '~/styles/utilities.css';

import { headerStyle } from './Layout.css';
import { useMenuItems, useNavigationMenuItems } from './Navigation.hooks';

export const NavigationMobileDrawer = () => {
  const navigationMenuItems = useNavigationMenuItems();
  const menuItems = useMenuItems();
  const logoutMutation = useLogout();

  const { t } = useTranslation(['common']);

  const invoicingItems = navigationMenuItems.filter((item) => item.group === 'invoicing');
  const communityItems = navigationMenuItems.filter((item) => item.group === 'community');

  return (
    <Navigation.Root render={<nav aria-label={t('common:navigation.main')} />}>
      <Drawer.Title className={srOnlyStyle}>{t('common:navigation.menu')}</Drawer.Title>

      <div className={headerStyle}>
        <Navigation.Logo to={routes.dashboard} />

        <Drawer.Close render={<Button aria-label={t('common:actions.close')} icon="CloseSmall" />} />
      </div>

      <Navigation.Body>
        <Navigation.Title>{t('common:sidebar.groupInvoicing')}</Navigation.Title>

        {invoicingItems.map((item) => (
          <Drawer.Close
            key={item.to}
            nativeButton={false}
            render={
              <Navigation.Link data-pf-id={item.productFruitsId} icon={item.icon} to={item.to}>
                {item.label}
              </Navigation.Link>
            }
          />
        ))}

        <Navigation.Title>{t('common:sidebar.groupSocial')}</Navigation.Title>

        {communityItems.map((item) => (
          <Drawer.Close
            key={item.to}
            nativeButton={false}
            render={
              <Navigation.Link data-pf-id={item.productFruitsId} icon={item.icon} to={item.to}>
                {item.label}
              </Navigation.Link>
            }
          />
        ))}

        <Navigation.Title>{t('common:sidebar.more')}</Navigation.Title>

        {menuItems.map((item) => (
          <Drawer.Close
            key={item.to}
            nativeButton={false}
            render={
              <Navigation.Link icon={item.icon} to={item.to}>
                {item.label}
              </Navigation.Link>
            }
          />
        ))}

        <Navigation.ExternalLink href="https://knowledge.creativeshelter.be/" icon="Help" target="_blank">
          {t('common:sidebar.help')}
        </Navigation.ExternalLink>

        <Navigation.Button icon="Logout" onClick={() => logoutMutation.mutate()}>
          {t('common:menu.logout')}
        </Navigation.Button>
      </Navigation.Body>
    </Navigation.Root>
  );
};
